import './fancybox';
import './ga4';
import './gallery';
import './menu';
import './swiper';
import Collapse from 'bootstrap/js/dist/collapse';
import Dropdown from 'bootstrap/js/dist/dropdown';
import Offcanvas from 'bootstrap/js/dist/offcanvas';

window.addEventListener('load', function () {
    document.querySelectorAll('.audio-player').forEach(player => {
        const audio = player.querySelector('.audio');
        const buttons = [...player.querySelectorAll('.playlist button')];

        let currentIndex = 0;

        function updateButtons() {
            buttons.forEach((btn, i) => {
                btn.classList.remove('btn-primary');
                btn.classList.add('btn-outline-primary');

                if (i === currentIndex) {
                    btn.classList.remove('btn-outline-primary');
                    btn.classList.add('btn-primary');
                }
            });
        }

        function loadTrack(index, autoplay = false) {
            currentIndex = index;

            audio.pause();
            audio.src = buttons[currentIndex].dataset.src;
            audio.load();

            updateButtons();

            if (autoplay) {
                audio.play().catch(() => {});
            }
        }

        loadTrack(0);

        buttons.forEach((btn, index) => {
            btn.addEventListener('click', () => {
                loadTrack(index, true);
            });
        });

        audio.addEventListener('ended', () => {
            const next = (currentIndex + 1) % buttons.length;

            loadTrack(next, true);
        });
    });
});